import ListColumn from './ListColumn'

export default ListColumn



// WEBPACK FOOTER //
// ./src/components/BetterList/Column/index.js